import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { USER_TYPE_ORGANIZATION } from '../../../../constants/constants';
import { GetAllMessage } from '../../../../API/endpoints/Message';
import { Avatar, Divider, List, Spin } from 'antd';
import MessageListItem from '../../../../components/MessageListItem';
import NotificationListItem from '../../../../components/NotificationListItem';
import { GetAllNotifications, markNotificationAsSeen } from '../../../../API/endpoints/Notifications';
import { io, Socket } from 'socket.io-client';
import { useNavigate } from 'react-router-dom';

const PAGE_SIZE = 20;
let socket: Socket;

interface Props {
  userProfile: any
}
const DashboardMessages = (props: Props) => {

  const { userProfile } = props;

  const navigate = useNavigate()

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [unreadCount, setUnreadCount] = useState(0);

  const loadMoreData = (pageNumber: number) => {
    if (loading) {
      return;
    }
    setLoading(true);
    setPage(pageNumber)

    GetAllNotifications('message', pageNumber, PAGE_SIZE)
      .then((res: any) => {
        const results = res?.data?.rows || [];
        if (pageNumber == 1) {
          setData(results);
        } else {
          setData([...data, ...results]);
        }

        setTotalCount(res?.data?.count);
        setUnreadCount(res?.unreadCount || 0);
        setLoading(false);
        setPage(page + 1);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadMoreData(1);
  }, [userProfile]);


  useEffect(() => {
    socket = io(process.env.REACT_APP_API_URL_SOCKET || "http://localhost:3001", { path: "/aeg" });

    socket.on("connect", () => {
      console.log("Connected:", socket.id);
    });

    if (userProfile?.id) {
      socket.emit("register-user", userProfile?.id);
    }


    socket.on("new-notification", (not) => {
      if (not?.type === "message") {
        setData((prev) => [not, ...prev]);
        setUnreadCount(prev => prev + 1)
      }

    });

    return () => {
      socket.disconnect();
    };
  }, [userProfile]);


  const handleClickNotification = async (item: any) => {
    if (item?.discovery_request_id) {
      const userUrl = userProfile?.partnerv2_id ? `partner-user` : `brand-user`
      navigate(`/${userUrl}/discovery/${item?.discovery_request_id}${item?.partner_id ? `?partnerID=${item?.partner_id}${item?.message_id ? `&messageID=${item?.message_id}` : ""}` : ""}`);

      try {
        const res = await markNotificationAsSeen(item.id)
      } catch (error) {
        console.error('error', error);

      }
    }
  }

  return (
    <div>
      <p className='text-end text-[#B54708] text-[10px] font-[500] mb-[8px]'>{unreadCount?.toString().padStart(2, "0")} Unread</p>
      <div
        id="scrollableDiv"
        className='h-[calc(100vh-324px)] overflow-auto overflow-scroll-bar pr-1'
      >
        <InfiniteScroll
          dataLength={data.length}
          next={() => loadMoreData(page + 1)}
          hasMore={data.length < totalCount}
          loader={<Spin size='small' />}
          endMessage={loading ? null : <Divider plain>It is all, nothing more.</Divider>}
          scrollableTarget="scrollableDiv"
        >
          <List
            dataSource={data}
            renderItem={(item, idx) => (
              <MessageListItem data={item} key={idx} onClick={() => handleClickNotification(item)} />
            )}
            loading={loading}
          />
        </InfiniteScroll>
      </div>
    </div>
  )
}

export default DashboardMessages